import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import AmenityModal from './AminityModal'; 
import { toast } from "react-toastify"; // ✅ Only toast is needed



const Amenities = () => {
    const { isSidebarOpen } = useSidebar();
    const [searchQuery, setSearchQuery] = useState('');
    const [amenities, setAmenities] = useState([]);
    const [filteredAmenities, setFilteredAmenities] = useState(amenities);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
      const [editingIndex, setEditingIndex] = useState(null);
    const [modalValue, setModalValue] = useState('');

            const BASE_URL = process.env.REACT_APP_API_BASE_URL;


    useEffect(() => {
        const filtered = amenities.filter((amenity) =>
            amenity.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredAmenities(filtered);
        setCurrentPage(1);
    }, [searchQuery, amenities]);

    const totalPages = Math.ceil(filteredAmenities.length / itemsPerPage);
    const currentData = filteredAmenities.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );


useEffect(() => {
    const fetchAmenities = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/amenity`);
            if (!response.ok) {
                throw new Error('Failed to fetch amenities');
            }

            const data = await response.json();
            setAmenities(data);
        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };

    fetchAmenities();
}, []);


    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

 const handleDelete = async (indexInPage) => {
    const actualIndex = (currentPage - 1) * itemsPerPage + indexInPage;
    const amenityToDelete = amenities[actualIndex];

    if (!window.confirm(`Are you sure you want to delete "${amenityToDelete.name}"?`)) return;

    try {
        const response = await fetch(`${BASE_URL}/api/amenity/${amenityToDelete.id}`, {
            method: "DELETE",
        });

        if (!response.ok) {
            throw new Error("Failed to delete amenity");
        }

        const updated = amenities.filter((_, index) => index !== actualIndex);
        setAmenities(updated);
        toast.success("Amenity deleted successfully!");
    } catch (error) {
        console.error("Error deleting amenity:", error);
        toast.error("Failed to delete amenity");
    }
};

    const handleAddClick = () => {
        setModalValue('');
        setEditingIndex(null);
        setIsModalOpen(true);
    };

    const handleEditClick = (indexInPage) => {
        const actualIndex = (currentPage - 1) * itemsPerPage + indexInPage;
        setModalValue(amenities[actualIndex].name);
        setEditingIndex(actualIndex);
        setIsModalOpen(true);
    };

    const handleModalSubmit = async (value) => {
    if (!value.trim()) return;

    try {
        if (editingIndex !== null) {
            const amenityToUpdate = amenities[editingIndex];

            const response = await fetch(`${BASE_URL}/api/amenity/${amenityToUpdate.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: value.trim() }),
            });

            if (!response.ok) {
                throw new Error("Failed to update amenity");
            }

            const updatedAmenity = await response.json();

            const updated = [...amenities];
            updated[editingIndex] = updatedAmenity;
            setAmenities(updated);
                        toast.success("Amenity updated successfully!");

        } else {
            const response = await fetch(`${BASE_URL}/api/amenity`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name: value.trim() }),
            });

            if (!response.ok) {
                throw new Error("Failed to create amenity");
            }

            const newAmenity = await response.json();
            setAmenities([...amenities, newAmenity]);
                        toast.success("Amenity added successfully!");

        }

        setIsModalOpen(false);
        setModalValue('');
        setEditingIndex(null);
    } catch (err) {
        console.error("Error submitting amenity:", err);
        toast.error("Failed to submit amenity");
    }
};


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Amenities</h1>
                    <button className="oms-add-btn" onClick={handleAddClick}>
                        Add Amenity
                    </button>
                </div>

                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search amenity..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th style={{ minWidth: '200px' }}>Amenity Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((amenity, index) => (
                                    <tr key={index}>
                                        <td>{amenity.name}</td>
                                        <td>
                                            <button className="edit-button"  onClick={() => handleEditClick(index)}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(index)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center' }}>
                                        No amenities found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>

      <AmenityModal
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
                initialValue={modalValue}
                onSubmit={handleModalSubmit}
            />        </>
    );
};

export default Amenities;
